export const mapToDeletion = <T extends object>(item: T) => ({
  ...item,
  _destroy: true,
})
